const moment = require('moment');

export const filterMoney = (amount, sign = ',') => {
  if (amount) {
    return amount
      .toString()
      .replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, (
        all,
        pre,
        groupOf3Digital
      ) => pre + groupOf3Digital.replace(/\d{3}/g, `${sign }$&`));
  }
  return 0;
};

export const filterToday = (value) => {
  // 要回傳的結果
  let returnText = 'null';
  const time = value.split(' ')[1].substring(0, value.split(' ')[1].length - 3);

  // 判斷上午下午
  if (moment(value).format('A') === 'AM') {
    returnText = `上午 ${time}`;
  } else {
    returnText = `下午 ${time}`;
  }
  return returnText;
};

export const filterWeek = (value) => {
  // 要回傳的結果
  let returnText = 'null';
  switch (parseInt(moment(value).format('E'), 16)) {
    case 7:
      returnText = '日';
      break;
    case 6:
      returnText = '六';
      break;
    case 5:
      returnText = '五';
      break;
    case 4:
      returnText = '四';
      break;
    case 3:
      returnText = '三';
      break;
    case 2:
      returnText = '二';
      break;
    case 1:
      returnText = '一';
      break;
    default:
      break;
  }
  return `${moment(value).format('M/D')} (${returnText})`;
};

export const filterText = (value) => {
  if (!value) return '';
  return value.replace(/\n/g, '<br>');
};
